<template>
    <Modal :visible="visible" @update:visible="v => v ? hide() : null"
           prevent-close>
        <template v-slot:title>
            {{ __('actions.preset.create_new') }}
        </template>
        <template v-slot:subtitle>
            {{ __('actions.preset.create_new_description') }}
        </template>

        <div class="form-group">
            <label class="font-weight-bold">
                {{ __('general.name') }}
            </label>
            <input type="text"
                   class="form-control form-control-solid"
                   placeholder="Package S"
                   v-model="newPreset.name"
            >
            <div class="text-danger" v-if="newPreset.errors.name">
                {{ newPreset.errors.name }}
            </div>
        </div>

        <PackageDimensionsForm v-model="newPreset.dimensions"
                               :form-errors="newPreset.errors"/>

        <template v-slot:footer>
            <div class="btn-group">
                <button class="btn btn-success px-10" @click="createPreset">
                    <i class="fas fa-plus-square mr-1"/>
                    {{ __('actions.create') }}
                </button>
                <button class="btn btn-default btn-hover-secondary px-10" @click="hide">
                    <i class="fas fa-times mr-1"/>
                    {{ __('actions.abort') }}
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>

import FormErrors from "@components/Form/FormErrors.vue";
import Modal from "@components/Modal.vue";
import PackageDimensionsForm from "@components/Packages/PackageDimensionsForm.vue";

export default {
    components: {PackageDimensionsForm, Modal, FormErrors},

    props: {
        storeUuid: String,
        visible: Boolean
    },

    data() {
        return {
            newPreset: this.$inertia.form({
                name: '',
                dimensions: null
            })
        }
    },

    methods: {
        createPreset() {
            this.newPreset.put(this.$route('store.package_dimension_presets.create', [this.storeUuid]), {
                onSuccess: () => {
                    this.hide();
                    this.newPreset.reset()
                    toastr.success(__('general.preset') + ' ' + __('general.created').toLowerCase());
                }
            })
        },

        hide() {
            this.$emit('hide')
        }
    },
}
</script>
